import styled from 'styled-components/macro';
import * as colors from 'components/common/colorConstants';

export const DropdownContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const DropdownButton = styled.button`
  width: 100%;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 8px;
  background-color: ${(props) => (props.disabled ? colors.lightGray7 : colors.white)};
  border: 1px solid ${(props) => (props.isOpen ? colors.blue1 : colors.lightGray21)};
  border-radius: 4px;
  font-family: 'Roboto', sans-serif;
  font-size: 11px;
  font-weight: 400;
  color: ${(props) => (props.disabled ? colors.inputGrey : colors.black4)};
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  outline: none;
  transition: border-color 0.2s ease;

  &:hover:not(:disabled) {
    border-color: ${colors.blue1};
  }

  &:focus {
    border-color: ${colors.blue1};
  }
`;

export const DropdownButtonText = styled.span`
  flex: 1;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const DropdownArrows = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 8px;
  flex-shrink: 0;
  width: 8px;
  height: 4px;

  img {
    width: 8px;
    height: 4px;
  }
`;

export const DropdownMenu = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  width: 100%;
  background: ${colors.white};
  border: 1px solid ${colors.lightGray21};
  border-radius: 4px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.12);
  padding: 4px 0;
  z-index: 1000;
`;

export const DropdownOption = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 12px;
  font-family: 'Roboto', sans-serif;
  font-size: 11px;
  font-weight: 400;
  color: ${colors.black4};
  background-color: ${(props) => (props.isSelected ? colors.blue1 : 'transparent')};
  cursor: pointer;
  transition: background-color 0.15s ease;

  ${(props) =>
    props.isSelected &&
    `
    color: ${colors.white};
  `}

  ${(props) =>
    props.isFocused &&
    !props.isSelected &&
    `
    background-color: ${colors.lightGray7};
    outline: 2px solid ${colors.blue1};
    outline-offset: -2px;
  `}

  &:hover {
    background-color: ${(props) => (props.isSelected ? colors.blue1 : colors.lightGray7)};
  }
`;
